import { getCurrentAccountNickName } from "../core/account-nickname";
import { getCurrentDomainName } from "../core/domain-name";

export function absoluteUrl(partial: string): string {
  const domainName = getCurrentDomainName();
  const accountNickName = getCurrentAccountNickName();

  return `${domainName ? `/${domainName}` : ""}${
    accountNickName ? `/${accountNickName}` : ""
  }${partial.startsWith("/") ? "" : "/"}${partial}`;
}
